module.exports = __webpack_public_path__ + "static/media/Warning_icon.99a5bac4.png";